<template>
  <div class="page-head-container">
    <div class="page-head clearfix">
      <div class="page-head-info columns clearfix">
        <div class="nav-bar">
          <a @click="navBack()">
            &lt; {{ $t('back') }}</a>
        </div>

        <div class="page-head-project-info clearfix">
          <div
            class="page-project-number"
            v-if="number"
          > {{ numberType }} {{ number || '' }}</div>
          <div class="row page-project-name">
            <div>{{ description }}</div>
          </div>
        </div>
        <div class="float-right clearfix">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CcdHeader',
  props: {
    number: [String, Number],
    description: String,
    numberType: String,
    companyId: [String, Number],
    tenancyId: [String, Number],
    from: String,
    contactId: [String, Number],
    isCircular: {
      type: Boolean,
      default: false,
    },
    goToPrevious: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navBack () {
      this.$router.goBack()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/common-header";
</style>
